import { render, staticRenderFns } from "./cxCorporateClaim.vue?vue&type=template&id=fc979118&"
import script from "./cxCorporateClaim.vue?vue&type=script&lang=js&"
export * from "./cxCorporateClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports